import _isEmpty from 'lodash/isEmpty';
import * as types from '../constants/ActionTypes';


export const contactRequestByEmail = (formFields) => {
  if (_isEmpty(formFields)) {
    return {
      type: types.RECEIVE_EMPTY_FIELDS,
    };
  }
  return {
    type: types.REQUEST_BY_EMAIL,
  };
};

export const contactByEmail = responseData => (dispatch) => {
  dispatch(contactRequestByEmail(responseData));
};

export const contactRequestByEmailNoIntent = (formFields) => {
  if (_isEmpty(formFields)) {
    return {
      type: types.RECEIVE_EMPTY_FIELDS_NO_INTENT,
    };
  }
  return {
    type: types.REQUEST_BY_EMAIL_NO_INTENT,
  };
};

export const contactByEmailNoIntent = responseData => (dispatch) => {
  dispatch(contactRequestByEmailNoIntent(responseData));
};
